import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { Link, useNavigate, useParams } from 'react-router-dom';

import { ClockIcon, StocksIcon } from 'ui-component/custom-icons/icons';
import { FaRegFileExcel, FaClock, FaPencilAlt } from 'react-icons/fa';
import ShipmentTrackingModal from 'ui-component/confirmation-dialogs/awbModal/ShipmentTrackingModal';
import ActionConfirmationModal from 'ui-component/confirmation-dialogs/actionConfirmationModal/ActionConfirmationModal';
import { PiInfoFill } from 'react-icons/pi';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import usePageTitle from 'hooks/usePageTitle';
import useIsMobile from 'utils/isMobileUtils';
import StatusBadge from 'ui-component/StatusBadge';
import WarehouseStockLists from './components/WarehouseStockLists';
import WarehouseStockHistories from './components/WarehouseStockHistories';
import WarehouseWidgetComponent from './components/WarehouseWidgetComponent';

function WarehouseDetails() {
	const [setPageTitle] = usePageTitle('Warehouse');
	useEffect(() => {
		return () => {
			setPageTitle(null);
		};
	}, []);
	const { id } = useParams();
	const history = useNavigate();
	const [isLoading, setIsLoading] = useState(false);
	const [warehouseDetails, setWarehouseDetails] = useState();
	const [showTrackingNoModal, setShowTrackingNoModal] = useState(false);
	const [activeComponent, setActiveComponent] = useState('stocks');


	const getWarehouseDetails = (callback = () => { }) => {
		setIsLoading(true);
		api.getWarehouseDetails(id).then((res) => {
			if (res?.status) {
				setIsLoading(false);
				setWarehouseDetails({
					...res.data,
				});
				callback(res.data);
			} else {
				history('/warehouses');
			}
		});

	};

	const handleFormSubmit = (e) => {
		toast.promise(
			api
				.updateShipmentAwb(id, {
					tracking_no: e?.trackingNo,
					shipment_id: showTrackingNoModal,
				})
				.then((res) => {
					if (res.status) {
						getWarehouseDetails()
						handleCloseShipmentTrackingModal();
					}
				}),
			{
				loading: 'Updating Tracking...',
				success: <b>Tracking Detail updated!</b>,
				error: <b>Could not Update Tracking Detail.</b>
			}
		);

	};

	const [confirmationDialog, setConfirmationDialog] = useState({
		show: false,
		message: '',
		title: '',
		handleConfirm: () => { },
		handleClose: () => { }
	});

	useEffect(() => {
		if (id) {
			getWarehouseDetails();
		}
	}, []);



	const s2ab = (s) => {
		const buf = new ArrayBuffer(s.length);
		const view = new Uint8Array(buf);
		for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
		return buf;
	};

	const handleDownloadImei = (id) => {
		api.downloadShipmentImei(id).then((res) => {
			// Create a workbook
			const wb = XLSX.utils.book_new();
			// Create a worksheet
			const ws = XLSX.utils.json_to_sheet(res?.data);
			XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

			// Convert the workbook to a binary string
			const wbBinaryString = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

			// Convert the binary string to a Blob
			const blob = new Blob([s2ab(wbBinaryString)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });


			saveAs(blob, `${warehouseDetails?.invoice_number} imeis.xlsx`);
		});
	}
	
	const handleCloseShipmentTrackingModal = (data) => {
		setShowTrackingNoModal('');
	};
	const redirectFunc = (data) => {
		setTimeout(() => {
			history(`/warehouses/${id}`);
		}, 1000);
	};

	const isMobile = useIsMobile();

	return (
		<>
			<div >
				<div className={`row ${isMobile ? 'm-0' : ''}`}>
					<div className={`${isMobile ? 'col-12 p-0' : 'col-11 offset-1 col-md-10 offset-md-1'}`}>
						{!isMobile ? (
							<div className="row" style={{ paddingBottom: '5px' }}>
								<div className="col-12">
									<div className="section-head hide-on-mobile" style={{ paddingLeft: 0 }}>
										<h2 style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '18px' }}>{warehouseDetails?.name}</h2>
										<div className="actions">
											<div style={{ width: '60px' }}>
												{warehouseDetails?.status === 1 ? (
													<StatusBadge itemStatus={'Active'} />
												) : (
													<StatusBadge itemStatus={'Inactive'} />
												)}
											</div>
											<button
												className="bulk-action btn-outlined-main ml8"
												style={{ marginLeft: '8px' }}
												onClick={() => {
													history(`/warehouses/edit/${warehouseDetails?.id}`);
												}}
											>
												<span className="menuIcon">
													<FaPencilAlt style={{ fontSize: '12px' }} />
												</span>
												<span>Edit</span>
											</button>
										</div>
									</div>
								</div>
							</div>
						) : (
							<div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
								<div className="header-bubble" />
								<div className="d-flex flex-column gap-2 " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
									<div
										style={{
											position: 'relative',
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
											minHeight: 38 // ensures enough height for the button
										}}
									>
										{' '}
										<button
											type="button"
											aria-label="Back"
											onClick={() => history(-1)}
											className="circle-back-btn"
											style={{
												position: 'absolute',
												left: 20,
												top: '50%',
												transform: 'translateY(-50%)'
											}}
										>
											{/* Replace with your fi arrow icon, example below */}
											<svg width="22" height="22" fill="none" viewBox="0 0 24 24">
												<path d="M15 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
											</svg>
										</button>
										<h5 style={{ textAlign: 'center', flex: 1, margin: 0 }}>{warehouseDetails?.name}</h5>
									</div>
									<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
										<button
											className="bulk-action btn-outlined-main ml8"
											style={{ marginLeft: '8px' }}
											onClick={() => {
												setActiveComponent('stocks')
											}}
										>
											<span className="menuIcon">
												<StocksIcon width={'14px'} height={'14px'} />
											</span>
											<span>Stocks</span>
										</button>
										<button
											className="bulk-action btn-outlined-main ml8"
											style={{ marginLeft: '8px' }}
											onClick={() => {
												setActiveComponent('history')
											}}
										>
											<span className="menuIcon">
												<ClockIcon width={'14px'} height={'14px'} />
											</span>
											<span>History</span>
										</button>
										<button
											className="bulk-action btn-outlined-main ml8"
											style={{ marginLeft: '8px' }}
											onClick={() => {
												history(`/warehouses/edit/${warehouseDetails?.id}`);
											}}
										>
											<span className="menuIcon">
												<FaPencilAlt style={{ fontSize: '12px' }} />
											</span>
											<span>Edit</span>
										</button>
									</div>
								</div>
							</div>
						)}
					</div>
				</div>
				<div className="row">
					{!isMobile ? (
						<div className="col-11 offset-1 col-md-10 offset-md-1">
							<div className="row">
								<div className="col-12 col-md-4">
									<WarehouseWidgetComponent
										isLoading={isLoading}
										title="Stocks"
										// details={productAmounts ?? {}}
										details={parseInt(warehouseDetails?.total_stocks) || 0}
										isPrice={false}
										type={1}
									/>
								</div>
								<div className="col-12 col-md-4">
									<WarehouseWidgetComponent
										isLoading={isLoading}
										title="Reserved"
										// details={productAmounts ?? {}}
										details={parseInt(warehouseDetails?.stocks_reserved) || 0}
										isPrice={false}
										type={2}
									/>
								</div>
								<div className="col-12 col-md-4">
									<WarehouseWidgetComponent
										isLoading={isLoading}
										title="Stock Values"
										details={parseFloat(warehouseDetails?.stock_value) || 0}
										isPrice={true}
										type={3}
									/>
								</div>
							</div>
							<div className="row">
								<div className="col-12">

									<div className="card" style={{ padding: '20px 20px 10px 20px' }}>
										<div className="row">
											<div className="col-12">

												<ul className="topListCom" style={{ marginTop: '-10px' }}>
													<li
														className={`fw-400 ${activeComponent === 'stocks' ? 'active font14' : 'font14'} ${isLoading && 'not-allowed-pointer'}`}
														
														onClick={() => {
															!isLoading && setActiveComponent('stocks');
														}}
													>
														Stocks
													</li>
													<li
														className={`fw-400 ${activeComponent === 'history' ? 'active font14' : 'font14'} ${isLoading && 'not-allowed-pointer'}`}
														onClick={() => {
															!isLoading && setActiveComponent('history');
														}}
													>
														History
													</li>
												</ul>
												{
													activeComponent == 'stocks' ? (
														<WarehouseStockLists id={id} />
													) : (
														<WarehouseStockHistories id={id} />
													)
												}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					) : (
						<div className="col-12">
							<div className="row" style={{ padding: '10px 20px' }}>
								<div className="col-12">
									<WarehouseWidgetComponent
										isLoading={isLoading}
										title="Stocks"
										// details={productAmounts ?? {}}
										details={parseInt(warehouseDetails?.total_stocks) || 0}
										isPrice={false}
										type={1}
									/>
								</div>
								<div className="col-12">
									<WarehouseWidgetComponent
										isLoading={isLoading}
										title="Reserved"
										// details={productAmounts ?? {}}
										details={parseInt(warehouseDetails?.stocks_reserved) || 0}
										isPrice={false}
										type={2}
									/>
								</div>
								<div className="col-12">
									<WarehouseWidgetComponent
										isLoading={isLoading}
										title="Stock Values"
										details={parseFloat(warehouseDetails?.stock_value) || 0}
										isPrice={true}
										type={3}
									/>
								</div>
							</div>
							{activeComponent == 'stocks' ? (
								<WarehouseStockLists id={id} />
							) : (
								<WarehouseStockHistories id={id} />
							)}
						</div>
					)}
				</div>
			</div>
			{showTrackingNoModal && (
				<ShipmentTrackingModal
					shipmentId={showTrackingNoModal}
					redirectionData={redirectFunc}
					onFormSubmit={handleFormSubmit}
					handleCloseShipmentTrackingModal={handleCloseShipmentTrackingModal}
				/>
			)}
			{confirmationDialog?.show && (
				<ActionConfirmationModal
					show={confirmationDialog?.show}
					message={confirmationDialog?.message}
					title={confirmationDialog?.title}
					customConfirmText={confirmationDialog?.customConfirm || 'Confirm'}
					customCancelText={confirmationDialog?.customCancel || 'Cancel'}
					customIcon={<PiInfoFill />}
					handleConfirm={confirmationDialog?.handleConfirm}
					handleClose={confirmationDialog?.handleClose}
				/>
			)}
		</>
	);
}

export default WarehouseDetails;
